import { ProductConfigurationQueryVariables } from "entities/dim-configuration/graphql/product-configuration.queries.generated"

type NullablePartial<T> = { [P in keyof T]?: T[P] | null | undefined }

export function getProductConfigurationQueryVariables(
  variables: NullablePartial<ProductConfigurationQueryVariables> & {
    productType: string
  }
): ProductConfigurationQueryVariables {
  return {
    ...variables,
    configurationKey: encodeURIComponent(variables.configurationKey ?? ""),
    dimensioningKey: variables.dimensioningKey ?? "",
    formData: variables.formData ?? "",
    variantKey:
      !variables.configurationKey &&
      !variables.dimensioningKey &&
      variables.variantKey !== variables.productType
        ? variables.variantKey ?? ""
        : ""
  }
}
